import React from 'react'

import formFields from '../data/formFields.js'
// import { Box } from '@mui/material'
// TODO: 06/25/23 consider what to do about  autoFocus={autoFocusFlag} flag in controlsArray in getFormFields
function getFormFields(
    pgID,
    handleInputChange,
    handleValue,
    controlSessionObj
) {
    const ar = formFields[pgID].map((setOfFields) => {
        let {
            control: Control,
            paramKey,
            displayValueArray,
            selectInputArray,
            ...attr
        } = setOfFields
        return (
            <Control
                key={paramKey}
                paramKey={paramKey}
                handleInputChange={handleInputChange}
                handleValue={handleValue}
                controlSessionObj={controlSessionObj}
                displayValueArray={displayValueArray}
                selectInputArray={selectInputArray}
                {...attr}
            />
        )
    })

    return ar
}

export default getFormFields
